import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'bookmarked',
    className: 'toggle-bookmark',
    width: '40px',
    orderable: false,
    render: (data, type, row) => {
      const isStarred = data === 'true'
      return renderToString(
        <button data-id={row.id} className={`toggle-bookmark button naked ${isStarred ? 'is-starred' : ''}`}>
          <span className='star-default'>
            <SvgIconsBookmarkStar solid={isStarred} />
          </span>
          <span className='star-hover'>
            {isStarred ? (
              <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.5' strokeLinecap='round' strokeLinejoin='round'>
                <path d='M6 6l12 12M18 6L6 18' />
              </svg>
            ) : (
              <SvgIconsBookmarkStar solid />
            )}
          </span>
        </button>
      )
    },
  },
  {
    data: 'name',
    width: '60%',
    className: 'bold',
    render: (data, type, row, meta) => {
      const isDiscarded = row['discarded'] === 'true'
      const name = isDiscarded ? data : <a href={`/admin/dashboards/${row.DT_RowId}/overview`}>{data}</a>
      return renderToString(
        <div>
          {name}
          {isDiscarded && <><br />
            <button className="button secondary small margin-top restore-dashboard" data-dashboard-id={row.DT_RowId}>Restore dashboard</button>
          </>}
        </div>
      )
    }
  },
  {
    data: 'status',
    width: '15%',
    orderable: false,
    render: (data, type, row, meta) => {
      const getClass = () => {
        const status = row['status']
        if (status === 'live') return 'accent'
        if (status === 'closed') return 'blue-100'
        return 'purple-60' // draft
      }

      return renderToString(
        <span className={`bold ${getClass()} capitalize`}>{row['status']}</span>
      )
    }
  },
  {
    data: 'target_count',
    width: '25%',
  },
  { data: 'created_at', visible: false },
]

const headers = ['', 'Name', 'Status', 'Number of people']

const filters = [
  {
    name: 'Status', column: 2, kind: 'radio', options: [
      { value: 'draft', label: 'Draft' },
      { value: 'live', label: 'Live' },
      { value: 'closed', label: 'Closed' },
    ]
  },
]

const sorters = [
  { column: 4, label: 'Created', order: 'desc' },
  { column: 3, label: 'Number of people', order: 'desc' },
  { column: 1, label: 'Alphabetically (A-Z)', order: 'asc' },
  { column: 1, label: 'Alphabetically (Z-A)', order: 'desc' },
]

const order = [[4, "desc"]]

export { columns, headers, filters, sorters, order }
